import React, { useRef, useState, useEffect} from 'react';
import {setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/hotel/placeActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import * as Yup from "yup";
import {
    INTERNATIONAL,
    LB_CODE,
    LB_END_DATE,
    LB_START_DATE, LB_TYPE,
    REQUIRED
} from "../../../components/i18n/i18n";
import {useForm} from "react-hook-form";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {GenericButton} from "../../../components/buttons/customButtons";
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import Separator from "../../../components/Separator";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {
    PH_CODE,
    PH_END_DATE,
    PH_START_DATE
} from "../../../components/i18n/placeHolders";
import Switch from "react-bootstrap-switch";
import EventLangs from "./_langs";
import {getCurrentDateForCodeField} from "../../../util/DateTools";
import {eventService} from "../../../jwt/_services/core/eventService";
import SelectGeneric from "../../../components/select/selectGeneric";
import {paramSettingsProvider} from "../../../providers/paramSettingsProvider";
import ImagePicker from "../../../components/imagePickerComponents/ImagePicker";
import {eventMediaService} from "../../../jwt/_services/core/eventMediaService";

const EventControllerForm = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { udn, app, editMode,  domainObject} = componentState?.data;

    const [status, setStatus] = useState( domainObject?.status !== undefined ? domainObject?.status : true);
    const [hasMap, setHasMap] = useState( domainObject?.hasMap !== undefined ? domainObject?.hasMap : null);
    const [hasItinerary, setHasItinerary] = useState( domainObject?.hasItinerary !== undefined ? domainObject?.hasItinerary : null);
    const [hasSections, setHasSections] = useState( domainObject?.hasSections !== undefined ? domainObject?.hasSections : null);
    const [useMemoriesAsPreview, setUseMemoriesAsPreview] = useState( domainObject?.useMemoriesAsPreview !== undefined ? domainObject?.useMemoriesAsPreview : null);

    const [aditionalCost, setAditionalCost] = useState( domainObject?.aditionalCost !== undefined ? domainObject?.aditionalCost : false);

    const [langs, setLangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || [];

    const [type, setType] = useState(domainObject?.type || null);
    const [openingTime, setOpeningTime] = useState(  domainObject?.openingTime || '' )
    const [closingTime, setClosingTime] = useState(  domainObject?.closingTime || '' )

    const [showModal, setShowModal] = useState(true);
    const modalRef = useRef(null);





    // Actualiza el formulario con los datos del objeto de dominio
    // Se utiliza posterior a la carga de imagenes desde ImagePicker ejecutando el metodo refresh()
    useEffect(() => {
        if (domainObject && domainObject.id && domainObject.langs) {
            reset({
                id: domainObject?.id,
                code: (domainObject?.code || `${udn?.code}_event_` + getCurrentDateForCodeField()).toUpperCase(), // AUTOCODE
                startDate: domainObject?.startDate,
                endDate: domainObject?.endDate,
                showOrder: domainObject?.showOrder,
                defaultImage: domainObject?.defaultImage,
                imageOverlay: domainObject?.imageOverlay,
                dividerImage: domainObject?.dividerImage,
                mainColor: domainObject?.mainColor,
                blogUrl: domainObject?.blogUrl,
                openingTime: domainObject?.openingTime,
                closingTime: domainObject?.closingTime,
            })
            setLangs(domainObject.langs || []);
            setStatus(domainObject.status);
        }
    }, [ domainObject ]);





    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
        startDate: Yup.string().required( REQUIRED ),
        endDate: Yup.string().required( REQUIRED ),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: (domainObject?.code || `${udn?.code}_event_` + getCurrentDateForCodeField()).toUpperCase(), // AUTOCODE
            startDate: domainObject?.startDate,
            endDate: domainObject?.endDate,
            showOrder: domainObject?.showOrder,
            defaultImage: domainObject?.defaultImage,
            imageOverlay: domainObject?.imageOverlay,
            dividerImage: domainObject?.dividerImage,
            mainColor: domainObject?.mainColor,
            blogUrl: domainObject?.blogUrl,
            openingTime: domainObject?.openingTime,
            closingTime: domainObject?.closingTime,
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            item : {
                ...data,
                openingTime: openingTime,
                closingTime: closingTime,
                udn: { id: udn?.id },
                type: type,
                langs: langs,

                hasItinerary: hasItinerary,
                hasSections: hasSections,
                useMemoriesAsPreview: useMemoriesAsPreview,
                hasMap: hasMap,
                status: status,
                aditionalCost: aditionalCost,
            }
        }

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, eventService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, eventService, dataRequest)
        }

        returnToList()
    };

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(false, false, false);
        props.onClose();
    }

    function notImplementedAction() {

    }


    const refreshObject = () => genericIndexedActions.get(path, eventService, domainObject?.id, app?.fbDataBase?.id);


    return (<>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={ editMode ? 'card-modal-medium' : 'card-modal-small'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    {
                        editMode &&  <>
                            <h2 className={'card-modal-title'} > { domainObject?.title?.toUpperCase() }</h2>
                            <br />
                            <h5 className={'card-modal-uid'} > { '     uid: ' + domainObject?.uid }</h5>
                        </>
                    }
                    <div className="top-right">
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode &&
                            <>
                                <GenericButton
                                    style={'table'}
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                                <TranslateButton item={domainObject} service={eventService} path={path} />
                                <GenericButton
                                    style={'danger-secondary'}
                                    toolTip={TT_DELETE}
                                    icon={'fa-trash'}
                                    permission={'delete'}
                                    onClick={notImplementedAction}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={returnToList}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>{LB_CODE}</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder={PH_CODE}
                                    innerRef={register}
                                />
                                {errors.code && <div className="invalid-feedback"
                                                     style={{'display': 'block'}}>{errors?.code?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{LB_TYPE}</Label>
                                <br/>
                                <SelectGeneric
                                    initialValue={type}
                                    setExternalValue={setType}
                                    customFilter={{item: {ps_key: 'xkynet_config_event_types'}}}
                                    provider={paramSettingsProvider}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{'Activo'}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={() => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="2">
                            <FormGroup>
                                <Label>{'Color'}</Label>
                                <Input
                                    type="color"
                                    name="mainColor"
                                    innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{'Orden'}</Label>
                                <Input
                                    type="number"
                                    min={0}
                                    step={1}
                                    name="showOrder"
                                    innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{'Habilitar venta'}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={aditionalCost}
                                    onChange={() => setAditionalCost(!aditionalCost)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>{LB_START_DATE}</Label>
                                <Input
                                    type="date"
                                    name="startDate"
                                    placeholder={PH_START_DATE}
                                    innerRef={register}
                                />
                                {errors.startDate && <div className="invalid-feedback"
                                                          style={{'display': 'block'}}>{errors?.starDate?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{LB_END_DATE}</Label>
                                <Input
                                    type="date"
                                    name="endDate"
                                    placeholder={PH_END_DATE}
                                    innerRef={register}
                                />
                                {errors.endDate && <div className="invalid-feedback"
                                                        style={{'display': 'block'}}>{errors?.endDate?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="3">
                        <FormGroup>
                            <Label>Hora de inicio</Label>
                            <Input
                                type="time"
                                name="openingTime"
                                value={openingTime}
                                onChange={e => setOpeningTime(e.target.value)}
                                innerRef={register}
                                placeholder="Ingrese hora"
                            />
                        </FormGroup>
                    </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Hora de fin</Label>
                                <Input
                                    type="time"
                                    name="closingTime"
                                    value={closingTime}
                                    onChange={e => setClosingTime(e.target.value)}
                                    innerRef={register}
                                    placeholder="Ingrese hora"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>{'Habilitar itinerario'}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={hasItinerary}
                                    onChange={() => setHasItinerary(!hasItinerary)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{'Habilitar secciones'}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={hasSections}
                                    onChange={() => setHasSections(!hasSections)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{'Usar memorias como preview'}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={useMemoriesAsPreview}
                                    onChange={() => setUseMemoriesAsPreview(!useMemoriesAsPreview)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                        <FormGroup>
                            <Label>{'Imagen divisor'}</Label>
                            <Input
                                type="text"
                                name="dividerImage"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{'Imagen overlay de mapa'}</Label>
                                <Input
                                    type="text"
                                    name="imageOverlay"
                                    innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{'Tiene mapa ?'}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={hasMap}
                                    onChange={() => setHasMap(!hasMap)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <FormGroup>
                                <Label>{'Url de Blog'}</Label>
                                <Input
                                    type="text"
                                    name="blogUrl"
                                    innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    {
                        domainObject?.id &&
                        <div className={'form-container'}>
                            <div className={''}>
                                <h2>{'Imagenes'}</h2>
                            </div>
                            <div className={''}>
                                <ImagePicker
                                    className={'event'}
                                    title={'Media'}
                                    app={app}
                                    service={eventService}
                                    baseMediaService={eventMediaService}
                                    objectMedia={domainObject}
                                    afterUpload={refreshObject}
                                />
                            </div>
                        </div>
                    }
                    <div className={'form-container'}>
                        <div className={''}>
                            <h2>{INTERNATIONAL}</h2>
                        </div>
                        <div className={''}>
                            <EventLangs langs={langs} setLangs={setLangs} translatableLangs={translatableLangs}/>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Form>

        {
            showModal && <LogHistoryModal
                ref={modalRef}
                item={domainObject}
            />
        }
    </>)
}

const mapStateToProps = _ => ({})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(EventControllerForm)